import { ChartPoint } from "../chart/ChartPoint";
import { DataPointResponse } from "./DataPointResponse";
import { Milestone } from "./Milestone";
import { MilestoneResponse } from "./MilestoneResponse";
import { Project } from "./Project";
import { ProjectResponse } from "./ProjectResponse";

export class ProjectResponseMapper {
  mapProjectResponseToProject = (projectResponse: ProjectResponse): Project => {
    return {
      id: projectResponse.id,
      name: projectResponse.name,
      milestones: projectResponse.milestones.map((milestone) =>
        this.mapMilestoneResponseToMilestone(milestone)
      ),
    };
  };

  mapMilestoneResponseToMilestone = (
    milestoneResponse: MilestoneResponse
  ): Milestone => {
    return {
      id: milestoneResponse.id,
      name: milestoneResponse.name,
      totalEstimate: this.sortChartPoints(milestoneResponse.totalEstimate),
      actualBurnUp: this.sortChartPoints(milestoneResponse.actualBurnup),
      estimateBurnUp: this.sortChartPoints(milestoneResponse.estimateBurnup),
      estimatedTotalHoursNeeded: this.sortChartPoints(
        milestoneResponse.estimatedTotalHoursNeeded
      ),
      totalTaskEstimates: this.sortChartPoints(
        milestoneResponse.totalTaskEstimates
      ),
      totalOfEstimatedCompleted: this.sortChartPoints(
        milestoneResponse.totalOfEstimatedCompleted
      ),
      totalTasks: this.sortChartPoints(milestoneResponse.totalTasks),
      state: milestoneResponse.state,
      gitLabCreateDate: milestoneResponse.gitLabCreateDate,
      isFetchingCompleted: false,
      openTaskCount: milestoneResponse.openTaskCount ?? 0,
      totalTaskCount: milestoneResponse.totalTaskCount ?? 0,
      forecast: milestoneResponse.forecast ?? null,
      forecastHistory: milestoneResponse.forecastHistory ?? [],
    };
  };

  sortChartPoints = (points: DataPointResponse[]): ChartPoint[] => {
    if (!points || points.length === 0) {
      return [];
    }
    return points
      .map((point) => ({
        date: point.date,
        value: point.value,
        dateCreated: point.dateCreated,
      }))
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  };
}
